import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/data/user/userSlice";
import themeReducer from "../features/data/theme/themeSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    theme: themeReducer,
  },
});
